var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreeResourses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.5C0 2.17188 1.09375 1 2.5 1H7.5C8.82812 1 10 2.17188 10 3.5V8.5H0V3.5ZM0 11H10V31H0V11ZM0 33.5H10V38.5C10 39.9062 8.82812 41 7.5 41H2.5C1.09375 41 0 39.9062 0 38.5V33.5ZM12.5 3.5C12.5 2.17188 13.5938 1 15 1H20C21.3281 1 22.5 2.17188 22.5 3.5V8.5H12.5V3.5ZM12.5 11H22.5V31H12.5V11ZM12.5 33.5H22.5V38.5C22.5 39.9062 21.3281 41 20 41H15C13.5938 41 12.5 39.9062 12.5 38.5V33.5ZM28.3594 32.0156L25 19.2031V12.1719L32.8125 10.0625L37.9688 29.4375L28.3594 32.0156ZM32.1875 7.64062L25 9.59375V1.85938L27.8125 1.15625C29.1406 0.765625 30.5469 1.54688 30.8594 2.875L32.1875 7.64062ZM28.9844 34.3594L38.5938 31.8594L39.8438 36.625C40.2344 37.9531 39.4531 39.2812 38.125 39.6719L33.3594 40.9219C32.0312 41.3125 30.625 40.5312 30.3125 39.2031L28.9844 34.3594Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeResourses);
export default __webpack_public_path__ + "static/media/free_resourses.ebef499c5f86ba86f488101b63cfc270.svg";
export { ForwardRef as ReactComponent };